import { Box, Flex, Text } from "@chakra-ui/react"

import {
  selectDepositActionAmount,
  selectDepositActionStatus,
  selectDepositActionToken,
  selectDepositActionType,
  useDappSelector,
} from "#/redux-state"
import { IS_MEZO_MAINNET, LOCK_TIMES } from "#/shared/constants"
import { bigIntToFloat, calculateDailyMats, formatMats } from "#/shared/utils"

import MatsDisplayWidget from "../MatsDisplayWidget"

import WithdrawalModalExtendButton from "./WithdrawalModalExtendButton"

type WithdrawalModalActionBoxProps = {
  onClick: () => void
}

export default function WithdrawalModalActionBox({
  onClick,
}: WithdrawalModalActionBoxProps) {
  const withdrawalStatus = useDappSelector(selectDepositActionStatus)
  const actionType = useDappSelector(selectDepositActionType)
  const token = useDappSelector(selectDepositActionToken)
  const withdrawalAmount = useDappSelector(selectDepositActionAmount)

  if (!token || IS_MEZO_MAINNET) return null

  const dailyMats = calculateDailyMats(
    bigIntToFloat(withdrawalAmount, 18, 18),
    LOCK_TIMES[0].multiplier,
    token,
  )

  const disableBoost =
    withdrawalStatus === "processing" ||
    withdrawalStatus === "in-progress" ||
    actionType === "redemption"

  return (
    <Box padding="24px 40px">
      <Flex justifyContent="space-between">
        <Flex flexDir="column" gap="16px" alignItems="flex-start">
          <Text color="primary.white.100" fontSize="24px" variant="bodyLarge">
            Continue earning instead?
          </Text>
          <WithdrawalModalExtendButton
            isDisabled={disableBoost}
            onClick={onClick}
          />
        </Flex>
        <Box color="primary.black.100" textAlign="right">
          <Text variant="numbersL" fontSize="64px" lineHeight="76px">
            {formatMats(dailyMats)}
          </Text>
          <MatsDisplayWidget tooltipPlacement="left" />
        </Box>
      </Flex>
    </Box>
  )
}
